import { getAnonymousVisitorId } from "./anonymousVisitor";

let transientSessionId;

export function getFeedbackSessionId() {
  try {
    const saved = window.localStorage.getItem("theofast-feedback-identity");
    if (saved) return saved;
    const stored = getAnonymousVisitorId(window.sessionStorage);
    if (stored) window.localStorage.setItem("theofast-feedback-identity", stored);
    if (stored) return stored;
  } catch { /* Keep posting available when browser storage is blocked. */ }
  if (!transientSessionId) transientSessionId = getAnonymousVisitorId({ getItem: () => null, setItem: () => {} });
  return transientSessionId;
}

export function createFeedbackSubmissionId() {
  return getAnonymousVisitorId({ getItem: () => null, setItem: () => {} });
}
